// extracted by mini-css-extract-plugin
module.exports = {"container":"Rfpq_container__1zgxo","form-container":"Rfpq_form-container__NEInJ"};